<template>
  <div id="map-container" class="columns is-gapless qa-map" style="margin-bottom: 0">
    <gmap-map
        ref="googleMap"
        :center="mapCenter"
        @click="onMapClicked"
        :zoom="9"
        :heading="heading"
        :options="options"
        map-type-id="terrain"
        style="width: 100%"
        class="mapbox-container">

      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                        @closeclick="onCloseInfoWindow">
      </gmap-info-window>

      <my-google-marker v-for="(item, index) in markers" :key="item._id"
                        :item="item"
                        @onMarkerClicked="onMarkerClicked(item, index)"
                        :is-selected="selectedDevice === item"
                        :draw-mode="null">
      </my-google-marker>
      <div slot="visible">
        <packaging-legend v-if="selectedProject && selectedDevice === null" @onDpFilterChanged="dpFilterChanged"></packaging-legend>
      </div>
    </gmap-map>
  </div>
</template>

<script>
import MyGoogleMarker from "@/modules/projects-module/components/my-google-marker/my-google-marker.vue";
import {
  getDateTime, getGmapPopupDPContent, getGmapPopupPackagingContent,
  getGmapPopupQaContent,
  gMapStyles
} from "@/utils/utils";
import {bbox, lineString} from "@turf/turf";
import {mapActions, mapGetters} from "vuex";
import PackagingLegend from "@/modules/data-packaging-module/components/packaging-legend/packaging-legend.vue";

export default {
  name: "g-map-data-packaging",
  components: {PackagingLegend, MyGoogleMarker},
  data() {
    return {
      mapCenter: {lat: -37.80193, lng: 144.94444},
      mapData: [],
      mapZoom: 10,
      drawMode: null,
      heading: 0,
      options: {styles: gMapStyles},
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -16
        }
      },
      filter: {site: true, device: true, sitePlan: true, planDevice: true}
    }
  },
  async mounted() {
    console.log('Gmap input sites: ', this.sitePlans)
    await this.$gmapApiPromiseLazy();

    console.log('Map: ', this.$refs.googleMap)


    this.$refs.googleMap.$mapObject.addListener('projection_changed', () => {
      console.log('Map heading', this.$refs.googleMap.$mapObject.heading)
      this.heading = this.$refs.googleMap.$mapObject.heading
    });
    if (this.selectedDevice) {
      console.log('Markers: ', this.markers)
      let index = this.markers.findIndex(marker => marker._id === this.selectedDevice._id)
      if (index !== -1) {
        this.zoomMapToSelectedDevice(true)
        this.toggleInfoWindow(this.markers[index], index)
      } else {
        if (!this.infoWinOpen) {
          this.zoomMapToSelectedDevice(true)
        }
        this.infoWinOpen = false
      }
    } else {
      this.zoomMapToSelectedDevice(true)
    }

  },
  methods: {
    ...mapActions({
      setSelectedPackagingDevice: 'dataPackagingModule/setSelectedPackagingDevice'
    }),
    dpFilterChanged(selection) {
      console.log('Legend changed: ', selection)
      //this.setLegendSelection(selection)
    },
    onCloseInfoWindow() {
      this.infoWinOpen = false
      this.setSelectedPackagingDevice(null)
      //this.zoomMapToSelectedSiteOrProject(true)
    },
    onMapClicked() {
      console.log('On map clicked')
      this.$emit('onMapClicked')
      this.setSelectedPackagingDevice(null)
      if (!this.infoWinOpen) {
        this.zoomMapToSelectedDevice(true)
      }
      this.infoWinOpen = false
    },
    onMarkerClicked(device, index) {
      console.log('On marker clicked', device)
      if (this.selectedDevice === device) {
        this.setSelectedPackagingDevice(null)
      } else {
        setTimeout(() => {
          this.setSelectedPackagingDevice(device)
        }, 500)
      }


      this.toggleInfoWindow(device, index)
      this.zoomMapToSelectedDevice(true, device)
    },
    toggleInfoWindow(device, idx) {
      this.infoWindowPos = {lat: device.location.coordinates[1], lng: device.location.coordinates[0]};
      this.setInfoWindowContent(device)
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    setInfoWindowContent(device) {
      if (device.objectType === 'device') {
        console.log('Toggle device: ', device)
        let additionalData = {
          status: this.status(device),
          statusColor: this.statusColor(device),
        }
        console.log('Additional data: ', additionalData)
        this.infoOptions.content = getGmapPopupPackagingContent(device, this.deviceStatusColor(device.currentStatus), this.selectedProject.project.name, additionalData)
      }
    },
    zoomMapToSelectedDevice(animate, device) {
      console.log('GMap, zoom to projects or sites')
      if(!this.$refs.googleMap.$mapObject){
        return
      }
      if (this.selectedProject != null) {
        //Zoom to selected site
        let coordinates = []
        if (device) {
          coordinates.push(device.location.coordinates)
        } else if (this.markers && this.markers.length > 0) {
          this.markers.forEach(device => {
            if (device.location) {
              coordinates.push(device.location.coordinates)
            }
          })
        }

        if (coordinates.length > 0) {
          console.log('COORDINATES', coordinates)

          if (coordinates.length > 1) {
            let line = lineString(coordinates);
            let bb = bbox(line);
            console.log('Bounding box:', bb)
            let boundsGMap = new window.google.maps.LatLngBounds()
            boundsGMap.extend({lat: bb[1], lng: bb[0]})
            boundsGMap.extend({lat: bb[3], lng: bb[2]})
            console.log('LatLngBounds: ', boundsGMap)
            this.$refs.googleMap.$mapObject.panTo(boundsGMap.getCenter());
            this.$refs.googleMap.$mapObject.fitBounds(boundsGMap, 100)
          } else {
            this.$refs.googleMap.$mapObject.panTo({lat: coordinates[0][1], lng: coordinates[0][0]});
          }
        } else if (animate) {
          this.$refs.googleMap.$mapObject.panTo(this.mapCenter);
        }
      } else {
        this.$refs.googleMap.$mapObject.panTo(this.mapCenter);
      }
    },
    deviceStatusColor(name) {
      if (this.$store.getters.getSettings) {
        let status = this.$store.getters.getSettings.deviceStatuses.find(status => status.name === name)
        if (status)
          return status.color
      }

      return '#ffffff'
    },
    onFilterChanged(data) {
      this.filter = data
      console.log('On filter changed: ', this.filter)
    },
    status(device) {
      if (device) {
        if (device.processingStatus && device.processingStatus === 'DataApproved') {
          return 'DATA APPROVED'
        }        else if (device.processingStatus && device.processingStatus === 'DataPackaged') {
          return 'DATA PACKAGED'
        }else if (device.packagedDataset && device.packagedDataset.version) {
          return 'READY'
        }
      }
      return 'NOT READY'
    },
    statusColor(device) {
      if (device) {
        if (device.processingStatus && device.processingStatus === 'DataApproved') {
          return '#8C84FF'
        } else if (device.processingStatus && device.processingStatus === 'DataPackaged') {
          return '#0C6051'
        }else if (device.packagedDataset && device.packagedDataset.version) {
          return '#1CAB80'
        }
      }
      return '#000000'
    },
  },
  computed: {
    ...mapGetters({
      selectedProject: 'dataPackagingModule/getSelectedPackagingProject',
      selectedDevice: 'dataPackagingModule/getSelectedPackagingDevice',
      getUser: 'getUserById',
      dpLegendSelection: 'dataPackagingModule/dpLegendSelection',
    }),
    mapHeight() {
      if (this.selectedProject == null) {
        return 'full-height-map'
      } else {
        return 'smaller-height-map'
      }
    },
    devices() {
      if (this.selectedProject) {
        console.log('SSelected project on map: ', this.selectedProject)
        let devices = []
        if(this.selectedProject.sites && this.selectedProject.sites.length > 0){
          this.selectedProject.sites.forEach(site => {
            devices.push(...site.devices)
          })
        }
        return devices
      }
      return []
    },
    markers() {
      let devices = []
      if (this.devices && this.devices.length > 0) {
        this.devices.forEach(device => {
          device.objectType = 'device'
          device.color = this.statusColor(device)
          if (device.location) {
            if(this.dpLegendSelection['READY'].value && device.packagedDataset && device.packagedDataset.version){
              devices.push(device)
            }else if (this.dpLegendSelection['DATA_APPROVED'].value && device.processingStatus === 'DataApproved') {
              devices.push(device)
            }else if (this.dpLegendSelection['DATA_PACKAGED'].value && device.processingStatus === 'DataPackaged') {
              devices.push(device)
            } else if (this.dpLegendSelection['NOT_READY'].value && device.processingStatus !== 'DataApproved' && device.processingStatus !== 'DataPackaged') {
              devices.push(device)
            }
          }
        })
      }
      console.log('MARKERS: ', devices)
      return devices
    }
  },
  watch: {
    dpLegendSelection: {
      handler: function (newVal, oldVal) {
        this.zoomMapToSelectedDevice(true)
      },
      deep: true
    },
    selectedProject: {
      handler: function (newVal, oldVal) {
        console.log('Selected project changed:', this.selectedProject)
        if ((oldVal && newVal === null) || (oldVal === null && newVal)) {
          this.zoomMapToSelectedDevice(true)
        }
      },
      deep: true
    },
    selectedDevice: {
      handler: function (newVal, oldVal) {
        if (this.selectedDevice === null) {
          if (!this.infoWinOpen) {
            this.zoomMapToSelectedDevice(true)
          }
          this.infoWinOpen = false
        } else {
          if (this.infoWinOpen) {
            this.setInfoWindowContent(this.selectedDevice)
          }
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped lang="scss">
.qa-map {
  height: 480px;
  transition: all .6s linear;
}

</style>